module.exports = __webpack_public_path__ + "img/bj-beaverjam-preview.de0d8e9f.gif";